import { render, staticRenderFns } from "./StatusPagamentoLoteIcon.vue?vue&type=template&id=676ea8e2&"
import script from "./StatusPagamentoLoteIcon.vue?vue&type=script&lang=js&"
export * from "./StatusPagamentoLoteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports